module.exports = __webpack_public_path__ + "fonts/6f45b3a8e301bbf1320e908a45d4bf85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/AlternativeDatePicker/image/icon-cal.svg
// module id = 1402
// module chunks = 0